<template>
  <ul class="main-menu">
    <li :class="{ active: item.route === path }" v-for="(item, i) in Sidebar" :key="i">
      <router-link :to="item.route" :class="{ 'nav-anim': true, active: item.route === path }">
        <span :class="item.icon"></span>
        <span class="link-text">{{ item.name }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import Sidebar from '../Sidebar'
import { computed, inject, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'Sidebar',
  setup() {
    const path = inject('path')
    const route = useRoute()
    const currentPath = computed(() => route.path)
    onMounted(() => {
      setTimeout(() => {
        path.value = currentPath.value
      }, 100)
    })

    watch(currentPath, (newState) => {
      path.value = newState
    })

    return {
      Sidebar,
      path
    }
  }
}
</script>
